namespace SorAraBul {
    export enum EducationLevel {
        okuryazarDegil = 0,
        ilkOgretim = 1,
        lise = 2,
        onLisans = 3,
        lisans = 4,
        yuksekLisans = 5,
        doktora = 6,
        diger = 7
    }
    Serenity.Decorators.registerEnumType(EducationLevel, 'SorAraBul.EducationLevel');
}
